import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { TableLayout } from '../../Menu/Stock/containers/Layout';
import { isEmpty } from "lodash"
import { TableHead, TableBody, TableRow, TableCell,Box } from '@material-ui/core';

class TechStats extends Component {
    state = {  }
    render() {
        return (
            <Box>
                <h4>Performance Techniciens</h4>
                <TableLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell>Nom</TableCell>
                            <TableCell>Nombre de Ventes</TableCell>
                            <TableCell>Nombre de Prospects</TableCell>
                            <TableCell>Commission</TableCell>
                            <TableCell>...</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!isEmpty(this.props.list) && !isEmpty(this.props.INSTALLERS) && this.props.list.map( techID => (
                            <TableRow key={techID}>
                                <TableCell>{this.props.INSTALLERS[techID].name}</TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        )

                        )}
                    </TableBody>
                </TableLayout>
            </Box>
        );
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        
        CLIENTS: state.clients
    }
}

// function mapDispatchToProps(dispatch){
//     return bindActionCreators({
//         fetchTechs,
//         updateTech,
//     }, dispatch)
// }
export default connect( mapStateToProps )(TechStats);